/* eslint-disable */

import AxiosInject from '@/services/axios';

export default function ResourcePattern(servicename, resource, injection) {
  const inject = typeof injection === 'function' ? injection({ resource, servicename, Api: AxiosInject }) : {};

  return {
    namespaced: true,

    state: {
      ...inject.state,
    },

    getters: {
      ...inject.getters,
    },

    actions: {
      ...inject.actions,
    },

    mutations: {
      ...inject.mutations,
    },
  };
}
/* eslint-enable */
